import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";

// Pages
import User from "@/pages/Dashboard/Pages/UserProfile.vue";
import Pricing from "@/pages/Dashboard/Pages/Pricing.vue";
import TimeLine from "@/pages/Dashboard/Pages/TimeLinePage.vue";
import RtlSupport from "@/pages/Dashboard/Pages/RtlSupport.vue";
import Login from "@/pages/Dashboard/Pages/Login.vue";
import Logout from "@/pages/Dashboard/Pages/Logout.vue";
import Register from "@/pages/Dashboard/Pages/Register.vue";
import Lock from "@/pages/Dashboard/Pages/Lock.vue";

// Components pages
import Buttons from "@/pages/Dashboard/Components/Buttons.vue";
import GridSystem from "@/pages/Dashboard/Components/GridSystem.vue";
import Panels from "@/pages/Dashboard/Components/Panels.vue";
import SweetAlert from "@/pages/Dashboard/Components/SweetAlert.vue";
import Notifications from "@/pages/Dashboard/Components/Notifications.vue";
import Icons from "@/pages/Dashboard/Components/Icons.vue";
import Typography from "@/pages/Dashboard/Components/Typography.vue";

// Forms pages
import RegularForms from "@/pages/Dashboard/Forms/RegularForms.vue";
import ExtendedForms from "@/pages/Dashboard/Forms/ExtendedForms.vue";
import ValidationForms from "@/pages/Dashboard/Forms/ValidationForms.vue";
import Wizard from "@/pages/Dashboard/Forms/Wizard.vue";

// TableList pages
import RegularTables from "@/pages/Dashboard/Tables/RegularTables.vue";
import ExtendedTables from "@/pages/Dashboard/Tables/ExtendedTables.vue";
import PaginatedTables from "@/pages/Dashboard/Tables/PaginatedTables.vue";

// Maps pages
import GoogleMaps from "@/pages/Dashboard/Maps/GoogleMaps.vue";
import FullScreenMap from "@/pages/Dashboard/Maps/FullScreenMap.vue";
import VectorMaps from "@/pages/Dashboard/Maps/VectorMaps.vue";

// Calendar
import Calendar from "@/pages/Dashboard/Calendar.vue";
// Charts
import Charts from "@/pages/Dashboard/Charts.vue";
import Widgets from "@/pages/Dashboard/Widgets.vue";

// Users
import UsersOverview from "@/pages/Dashboard/Users/UsersOverview.vue";
import UserEdit from "@/pages/Dashboard/Users/UserEdit.vue";
import DeletedUsersOverview from "@/pages/Dashboard/Users/DeletedUsersOverview.vue";

// User Roles
import UserRolesOverview from "@/pages/Dashboard/UserRoles/UserRolesOverview.vue";
import UserRoleEdit from "@/pages/Dashboard/UserRoles/UserRoleEdit.vue";

// User field groups
import UserFieldGroupsOverview from "@/pages/Dashboard/UserFields/UserFieldGroupsOverview.vue";
import UserFieldGroupEdit from "@/pages/Dashboard/UserFields/UserFieldGroupEdit.vue";

// User field type options
import UserFieldTypeOptionsOverview from "@/pages/Dashboard/UserFields/UserFieldTypeOptionsOverview.vue";
import UserFieldTypeOptionsEdit from "@/pages/Dashboard/UserFields/UserFieldTypeOptionsEdit.vue";

// User fields
import UserFieldEdit from "@/pages/Dashboard/UserFields/UserFieldEdit.vue";

// Bus Routes
import RoutesOverview from "@/pages/Dashboard/Routes/RoutesOverview.vue";
import RoutePeriodsOverview from "@/pages/Dashboard/Routes/RoutePeriodsOverview.vue";
import RouteEdit from "@/pages/Dashboard/Routes/RouteEdit.vue";
import RoutePeriodEdit from "@/pages/Dashboard/Routes/RoutePeriodEdit.vue";

// Bus Shifts
import ShiftsOverview from "@/pages/Dashboard/Shifts/ShiftsOverview.vue";
import ShiftPeriodsOverview from "@/pages/Dashboard/Shifts/ShiftPeriodsOverview.vue";
import ShiftEdit from "@/pages/Dashboard/Shifts/ShiftEdit.vue";
import ShiftPeriodEdit from "@/pages/Dashboard/Shifts/ShiftPeriodEdit.vue";

// Notifications
import NotificationsMailLogOverview from "@/pages/Dashboard/Notifications/NotificationsMailLogOverview.vue";

// National Holidays
import HolidaysOverview from "@/pages/Dashboard/Holidays/HolidaysOverview.vue";
import HolidayEdit from "@/pages/Dashboard/Holidays/HolidayEdit.vue";

// Drivers
import DriversOverview from "@/pages/Dashboard/Drivers/DriversOverview.vue";
import DriversEdit from "@/pages/Dashboard/Drivers/DriversEdit.vue";
import DriversFieldGroupsOverview from "@/pages/Dashboard/Drivers/DriversFieldGroupsOverview.vue";
import DriversFieldGroupsEdit from "@/pages/Dashboard/Drivers/DriversFieldGroupsEdit.vue";
import DriversFieldEdit from "@/pages/Dashboard/Drivers/DriversFieldEdit.vue";
import DriversUnavailablePeriodEdit from "@/pages/Dashboard/Drivers/DriversPeriodsUnavailableEdit";
import DriversPeriodsAvailableOverview from "@/pages/Dashboard/Drivers/DriversPeriodsAvailableOverview";
import DriversPeriodAvailableEdit from "@/pages/Dashboard/Drivers/DriversPeriodAvailableEdit";
import DriversExpenses from "@/pages/Dashboard/Drivers/DriversExpenses";

// Drivers import
import ImportsOverview from "@/pages/Dashboard/Imports/ImportsOverview.vue";
import ImportEdit from "@/pages/Dashboard/Imports/ImportEdit.vue";
import ImportTemplatesOverview from "@/pages/Dashboard/Imports/ImportTemplatesOverview.vue";
import ImportTemplateEdit from "@/pages/Dashboard/Imports/ImportTemplateEdit.vue";

// Schedules
import SchedulesOverview from "@/pages/Dashboard/Schedules/SchedulesOverview.vue";
import SchedulesEdit from "@/pages/Dashboard/Schedules/ScheduleEdit.vue";
import SchedulesReportDriversScheduledShifts from "@/pages/Dashboard/Schedules/SchedulesReportDriversScheduledShifts.vue";
import SchedulesReportDriversAvailability from "@/pages/Dashboard/Schedules/SchedulesReportDriversAvailability.vue";
import SchedulesReportDriversLastScheduled from "@/pages/Dashboard/Schedules/SchedulesReportDriversLastScheduled.vue";

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "buttons",
      name: "Buttons",
      components: { default: Buttons }
    },
    {
      path: "grid-system",
      name: "Grid System",
      components: { default: GridSystem }
    },
    {
      path: "panels",
      name: "Panels",
      components: { default: Panels }
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      components: { default: SweetAlert }
    },
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications }
    },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons }
    },
    {
      path: "typography",
      name: "Typography",
      components: { default: Typography }
    }
  ]
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  name: "Forms",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      components: { default: RegularForms }
    },
    {
      path: "extended",
      name: "Extended Forms",
      components: { default: ExtendedForms }
    },
    {
      path: "validation",
      name: "Validation Forms",
      components: { default: ValidationForms }
    },
    {
      path: "wizard",
      name: "Wizard",
      components: { default: Wizard }
    }
  ]
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  name: "Tables",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "regular",
      name: "Regular Tables",
      components: { default: RegularTables }
    },
    {
      path: "extended",
      name: "Extended Tables",
      components: { default: ExtendedTables }
    },
    {
      path: "paginated",
      name: "Pagianted Tables",
      components: { default: PaginatedTables }
    }
  ]
};

let usersMenu = {
  path: "/users",
  component: DashboardLayout,
  redirect: "/users/overview",
  name: "Users",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "overview",
      name: "Gebruikers overzicht",
      components: { default: UsersOverview }
    },
    {
      path: "add",
      name: "Gebruiker toevoegen",
      components: { default: UserEdit }
    },
    {
      path: "edit/:id",
      name: "Gebruiker bewerken",
      components: { default: UserEdit }
    },
    {
      path: "overview/deleted",
      name: "Verwijderde gebruikers",
      components: { default: DeletedUsersOverview }
    }
  ]
};

let userRolesMenu = {
  path: "/user_roles",
  component: DashboardLayout,
  redirect: "/user_roles/overview",
  name: "User roles",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "overview",
      name: "Gebruikersrollen overzicht",
      components: { default: UserRolesOverview }
    },
    {
      path: "add",
      name: "Gebruikersrol toevoegen",
      components: { default: UserRoleEdit }
    },
    {
      path: "edit/:id",
      name: "Gebruikersrol bewerken",
      components: { default: UserRoleEdit }
    }
  ]
};

let userFieldGroupsMenu = {
  path: "/user_field_groups",
  component: DashboardLayout,
  redirect: "/user_field_groups/overview",
  name: "User field groups",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "overview",
      name: "Gebruikers veld groepen overzicht",
      components: { default: UserFieldGroupsOverview }
    },
    {
      path: "add",
      name: "Gebruikers veld groep toevoegen",
      components: { default: UserFieldGroupEdit }
    },
    {
      path: "edit/:id",
      name: "Gebruikers veld groep bewerken",
      components: { default: UserFieldGroupEdit }
    },
    {
      path: "group/:groupId/field/add",
      name: "Gebruikers veld toevoegen",
      components: { default: UserFieldEdit }
    },
    {
      path: "group/:groupId/field/edit/:id",
      name: "Gebruikers veld bewerken",
      components: { default: UserFieldEdit }
    }
  ]
};

let userFieldTypeMenu = {
  path: "/user_field_types",
  component: DashboardLayout,
  redirect: "/user_field_types/type/options",
  name: "User field types",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "type/options",
      name: "Gebruikers veld type opties bewerken",
      components: { default: UserFieldTypeOptionsOverview }
    },
    {
      path: "type/options/edit/:id",
      name: "Gebruikers veld type opties bewerken",
      components: { default: UserFieldTypeOptionsEdit }
    }
  ]
};

let driverFieldGroupsMenu = {
  path: "/driver_field_groups",
  component: DashboardLayout,
  redirect: "/driver_field_groups/overview",
  name: "Driver field groups",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "overview",
      name: "Gebruikers veld groepen overzicht",
      components: { default: UserFieldGroupsOverview }
    },
    {
      path: "add",
      name: "Gebruikers veld groep toevoegen",
      components: { default: UserFieldGroupEdit }
    },
    {
      path: "edit/:id",
      name: "Gebruikers veld groep bewerken",
      components: { default: UserFieldGroupEdit }
    },
    {
      path: "group/:groupId/field/add",
      name: "Gebruikers veld toevoegen",
      components: { default: UserFieldEdit }
    },
    {
      path: "group/:groupId/field/edit/:id",
      name: "Gebruikers veld bewerken",
      components: { default: UserFieldEdit }
    }
  ]
};

let driversMenu = {
  path: "/drivers",
  component: DashboardLayout,
  redirect: "/drivers/overview",
  name: "Drivers",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "overview",
      name: "Chauffeurs overzicht",
      components: { default: DriversOverview }
    },
    {
      path: "add",
      name: "Chauffeur toevoegen",
      components: { default: DriversEdit }
    },
    {
      path: "edit/:id",
      name: "Chauffeur bewerken",
      components: { default: DriversEdit }
    },
    {
      path: "group/overview",
      name: "Chauffeur veld groepen overzicht",
      components: { default: DriversFieldGroupsOverview }
    },
    {
      path: "group/add",
      name: "Chauffeur veld groep toevoegen",
      components: { default: DriversFieldGroupsEdit }
    },
    {
      path: "group/edit/:id",
      name: "Chauffeur veld groep bewerken",
      components: { default: DriversFieldGroupsEdit }
    },
    {
      path: "group/:groupId/field/add",
      name: "Chauffeur veld toevoegen",
      components: { default: DriversFieldEdit }
    },
    {
      path: "group/:groupId/field/edit/:id",
      name: "Chauffeur veld bewerken",
      components: { default: DriversFieldEdit }
    },
    {
      path: "edit/:userId/unavailablePeriod/add",
      name: "Chauffeur niet beschikbare periode toevoegen",
      components: { default: DriversUnavailablePeriodEdit }
    },
    {
      path: "edit/:userId/unavailablePeriod/edit/:id",
      name: "Chauffeur niet beschikbare periode bewerken",
      components: { default: DriversUnavailablePeriodEdit }
    },
    {
      path: ":userId/availablePeriod/",
      name: "Chauffeur beschikbare perioden overzicht",
      components: { default: DriversPeriodsAvailableOverview }
    },
    {
      path: "edit/:userId/availablePeriod/add/:routeId/:shiftId/:weekType",
      name: "Chauffeur beschikbare periode toevoegen",
      components: { default: DriversPeriodAvailableEdit }
    },
    {
      path: "edit/:userId/availablePeriod/edit/:ids",
      name: "Chauffeur beschikbare periode bewerken",
      components: { default: DriversPeriodAvailableEdit }
    },
    {
      path: "expenses",
      name: "Export onkosten vergoedingen per chauffeur",
      components: { default: DriversExpenses }
    },
    {
      path: "imports/templates/overview",
      name: "Import template overzicht",
      components: { default: ImportTemplatesOverview }
    },
    {
      path: "imports/templates/add",
      name: "Import template toevoegen",
      components: { default: ImportTemplateEdit }
    },
    {
      path: "imports/templates/edit/:id",
      name: "Import template bewerken",
      components: { default: ImportTemplateEdit }
    },
    {
      path: "imports/overview",
      name: "Import overzicht",
      components: { default: ImportsOverview }
    },
    {
      path: "imports/add",
      name: "Import toevoegen",
      components: { default: ImportEdit }
    },
    {
      path: "imports/edit/:id",
      name: "Import bewerken",
      components: { default: ImportEdit }
    }
  ]
};

let routesMenu = {
  path: "/routes",
  component: DashboardLayout,
  redirect: "/routes/overview",
  name: "Routes",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "overview",
      name: "Routes overzicht",
      components: { default: RoutesOverview }
    },
    {
      path: "periods/:id",
      name: "Route perioden overzicht",
      components: { default: RoutePeriodsOverview }
    },
    {
      path: "add",
      name: "Route toevoegen",
      components: { default: RouteEdit }
    },
    {
      path: "edit/:id",
      name: "Route bewerken",
      components: { default: RouteEdit }
    },
    {
      path: "periods/:routeId/add",
      name: "Route periode toevoegen",
      components: { default: RoutePeriodEdit }
    },
    {
      path: "periods/:routeId/edit/:id",
      name: "Route periode bewerken",
      components: { default: RoutePeriodEdit }
    }
  ]
};

let shiftsMenu = {
  path: "/shifts",
  component: DashboardLayout,
  redirect: "/shifts/overview",
  name: "Shifts",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "overview",
      name: "Diensten overzicht",
      components: { default: ShiftsOverview }
    },
    {
      path: "periods/:id",
      name: "Dienst perioden overzicht",
      components: { default: ShiftPeriodsOverview }
    },
    {
      path: "add",
      name: "Dienst toevoegen",
      components: { default: ShiftEdit }
    },
    {
      path: "edit/:id",
      name: "Dienst bewerken",
      components: { default: ShiftEdit }
    },
    {
      path: "periods/:shiftId/add",
      name: "Dienst periode toevoegen",
      components: { default: ShiftPeriodEdit }
    },
    {
      path: "periods/:shiftId/edit/:id",
      name: "Dienst periode bewerken",
      components: { default: ShiftPeriodEdit }
    }
  ]
};

let schedulesMenu = {
  path: "/schedules",
  component: DashboardLayout,
  redirect: "/schedules/overview",
  name: "Schedules",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "overview",
      name: "Rooster overzicht",
      components: { default: SchedulesOverview }
    },
    {
      path: "add",
      name: "Rooster toevoegen",
      components: { default: SchedulesEdit }
    },
    {
      path: "edit/:id",
      name: "Rooster bewerken",
      components: { default: SchedulesEdit }
    },
    {
      path: "report/drivers-availability",
      name: "Beschikbaarheid chauffeurs",
      components: { default: SchedulesReportDriversAvailability }
    },
    {
      path: "report/drivers-scheduled-shifts",
      name: "Overzicht diensten",
      components: { default: SchedulesReportDriversScheduledShifts }
    },
    {
      path: "report/drivers-last-scheduled",
      name: "Laaste keer ingeroosterd",
      components: { default: SchedulesReportDriversLastScheduled }
    }
  ]
};

let notificationsMenu = {
  path: "/notifications",
  component: DashboardLayout,
  redirect: "/notifications/mail-log",
  name: "mail-log",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "mail-log",
      name: "E-mail log",
      components: { default: NotificationsMailLogOverview }
    }
  ]
};

let holidaysMenu = {
  path: "/holidays",
  component: DashboardLayout,
  redirect: "/holidays/overview",
  name: "Holidays",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "overview",
      name: "Feestdagen overzicht",
      components: { default: HolidaysOverview }
    },
    {
      path: "add",
      name: "Feestdag toevoegen",
      components: { default: HolidayEdit }
    },
    {
      path: "edit/:id",
      name: "Feestdag bewerken",
      components: { default: HolidayEdit }
    }
  ]
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  redirect: "/maps/google",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "google",
      name: "Google Maps",
      components: { default: GoogleMaps }
    },
    {
      path: "full-screen",
      name: "Full Screen Map",
      meta: {
        hideContent: true,
        hideFooter: true,
        navbarAbsolute: true
      },
      components: { default: FullScreenMap }
    },
    {
      path: "vector-map",
      name: "Vector Map",
      components: { default: VectorMaps }
    }
  ]
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  children: [
    {
      path: "user",
      name: "User Page",
      components: { default: User }
    },
    {
      path: "timeline",
      name: "Timeline Page",
      components: { default: TimeLine }
    },
    {
      path: "rtl",
      name: "وحة القيادة",
      meta: {
        rtlActive: true
      },
      components: { default: RtlSupport }
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  meta: {
    guest: true
  },
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        guest: true
      }
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing
    },
    {
      path: "/lock",
      name: "Lock",
      component: Lock
    }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home"
  },
  usersMenu,
  userRolesMenu,
  userFieldGroupsMenu,
  userFieldTypeMenu,
  driverFieldGroupsMenu,
  driversMenu,
  routesMenu,
  shiftsMenu,
  schedulesMenu,
  notificationsMenu,
  holidaysMenu,
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  authPages,
  {
    path: "/",
    component: DashboardLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard }
      },
      {
        path: "calendar",
        name: "Calendar",
        components: { default: Calendar }
      },
      {
        path: "charts",
        name: "Charts",
        components: { default: Charts }
      },
      {
        path: "widgets",
        name: "Widgets",
        components: { default: Widgets }
      }
    ]
  }
];

export default routes;
